import { useEffect } from 'react'
import { useSignal } from '@preact/signals-react'
import { postSubmit } from '@ui-seeker/utils'

import { isSystemBusy } from '@signals'
import { BACKEND_APIS } from '@constants'
import { reloadSkuGroupFilters } from '../../@signals'


export default function useSkuGroupUserTableFilters() {
    const data = useSignal([])
    const isLoading = useSignal(false)

    const load = () => {
        isLoading.value = true
        postSubmit(`${BACKEND_APIS.MANAGEMENT}/sku-group/user-context`, {})
            .then(res => {
                data.value = res
                isLoading.value = false
            })
            .catch(() => {
                isSystemBusy.value = true
                isLoading.value = false
            })
    }

    useEffect(() => { load() }, [])

    useEffect(() => {
        if (reloadSkuGroupFilters.value) load()
    }, [reloadSkuGroupFilters.value])

    return {
        data: data.value,
        isLoading: isLoading.value,
    }
}
